import {observer} from "mobx-react";
import {useStores} from "hooks/useStores";
import {Title2} from "../../../../styles/business-components";
import * as S from './styles'

import Image1 from '../../../../assets/images/business/b_m_cnt5_img1.png';
import Image2 from '../../../../assets/images/business/b_m_cnt5_img2.png';
import Image3 from '../../../../assets/images/business/b_m_cnt5_img3.png';
import {Button, Variant} from "../../../Button";
import {Uppercase} from "../../../../styles/components";

export const Content5 = observer(() => {

  const { businessStore } = useStores();

  return (
    <S.Container>
        <S.Content>
            <S.TitleBlock>
                <Title2>ЛЕГКО ОФОРМИТЬ</Title2>
                <S.Text>
                    Основываясь на Ваших индивидуальных требованиях и пожеланиях, наша команда с удовольствием поможет
                    подобрать наиболее подходящий и выгодный для Вас пакет услуг. Наша цель - удовлетворить Ваши потребности наилучшим образом.
                </S.Text>
            </S.TitleBlock>
        </S.Content>
        <S.CardBlock>
            <S.Content>
                <S.Cards>
                    <S.Card>
                        <S.CardImage src={Image1}/>
                        <S.CardText>Заполните  форму</S.CardText>
                    </S.Card>
                    <S.Card>
                        <S.CardImage src={Image2}/>
                        <S.CardText>Выберите тариф</S.CardText>
                    </S.Card>
                    <S.Card>
                        <S.CardImage src={Image3}/>
                        <S.CardText>Отправьте заявку</S.CardText>
                    </S.Card>
                </S.Cards>
            </S.Content>
        </S.CardBlock>
        <S.Content>
            <S.ButtonBlock>
                <Button variant={Variant.Business} onClick={businessStore.toggleFeedback}><Uppercase>Перейти к оформлению</Uppercase></Button>
            </S.ButtonBlock>
        </S.Content>
    </S.Container>
  )
})